export default __webpack_public_path__ + "static/media/logo-small.069fd8da.svg";